import { Controller } from '@hotwired/stimulus'

export const MAIN_NAVIGATION_OPEN_BODY_CLASS = 'main-navigation-is-open'

export default class extends Controller {
  static targets = ['navigationPanel', 'mobileNavBar']

  connect() {
    window.addEventListener('resize', this.handleResize.bind(this))
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener('resize', this.handleResize.bind(this))
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    if (!this.hasMobileNavBarTarget) return
    this.mobileNavBarTarget.classList.toggle('scrolled', window.scrollY > 4)
  }

  open() {
    if (window.innerWidth >= 768) return

    this.navigationPanelTarget.classList.add('transition-transform', 'duration-400')
    this.navigationPanelTarget.classList.remove('-translate-x-full')
    this.navigationPanelTarget.classList.add('translate-x-0')
    document.body.classList.add(MAIN_NAVIGATION_OPEN_BODY_CLASS)
  }

  close() {
    if (window.innerWidth >= 768) return

    this.navigationPanelTarget.classList.add('transition-transform', 'duration-400')
    this.navigationPanelTarget.classList.remove('translate-x-0')
    document.body.classList.remove(MAIN_NAVIGATION_OPEN_BODY_CLASS)
    this.navigationPanelTarget.classList.add('-translate-x-full')
  }

  removeOpenClass(event) {
    if (window.innerWidth >= 768) return
    if (!event.target.closest('a')) return

    document.body.classList.remove(MAIN_NAVIGATION_OPEN_BODY_CLASS)
  }

  closeImmediately() {
    this.navigationPanelTarget.classList.remove('transition-transform', 'duration-400')
    this.navigationPanelTarget.classList.remove('translate-x-0')
    document.body.classList.remove(MAIN_NAVIGATION_OPEN_BODY_CLASS)
    this.navigationPanelTarget.classList.add('-translate-x-full')
  }

  handleResize() {
    if (window.innerWidth >= 768) {
      this.navigationPanelTarget.classList.remove('transition-transform', 'duration-400', 'translate-x-0', '-translate-x-full')
    } else {
      this.navigationPanelTarget.classList.add('-translate-x-full')
    }
  }
}
